import MODEL_ICON_MAP from "../Constants/modelIcons";

export const getModelIcon = (modelName: string): string | null => {
  const match = MODEL_ICON_MAP.find((entry) =>
    modelName.toLowerCase().includes(entry.pattern)
  );
  return match?.icon ?? null;
};
